<template>
  <el-dialog title="详情" :visible.sync="detailDialogVisible" width="723px" center>
    <div class="detail">
      <div class="baseInfo">
        <el-form v-loading='formLoading' :model="detailData" label-position="left">
          <el-row>
            <el-col :span="12">
              <el-form-item label="供应商类型:">
                <span>{{ detailData.type | getType }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供应商:">
                <span>{{ detailData.supplierName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="合同名称:">
                <span>{{ detailData.contractName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同编号:">
                <span>{{ detailData.contractCode }}</span>
              </el-form-item>
            </el-col>
          </el-row>
<!--          <el-row>-->
<!--            <el-col :span="12">-->
<!--              <el-form-item label="开始时间:">-->
<!--                <span>{{ detailData.startDate }}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :span="12">-->
<!--              <el-form-item label="结束时间:">-->
<!--                <span>{{ detailData.endDate }}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--          </el-row>-->
          <el-row>
            <el-col :span="12">
              <el-form-item label="对账时间:">
                <span>{{ detailData.reconciliationTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class='flex-center-center mt10 '>
        <el-button size='medium' class='searchBtn' @click='dialogClose'>确认</el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {detailContract} from "@/service/warehouse";

export default {
  data(){
    return{
      detailDialogVisible: false,
      detailData: {},
      formLoading: false,
    }
  },
  mounted() {
    this.defaultForm = JSON.parse(JSON.stringify(this.detailData));
  },
  filters:{
    getType(val) {
      switch (val) {
        case 0:
          return '公路';
        case 1:
          return '水路';
        case 2:
          return '港口及其它';
      }
    },
  },
  methods: {
    init(id) {
      this.detailDialogVisible = true;
      this.detailData = JSON.parse(JSON.stringify(this.defaultForm));
      this.getDetails(id)
    },
    dialogClose(){
      this.detailDialogVisible = false;
      this.detailData = JSON.parse(JSON.stringify(this.defaultForm));
    },
    async getDetails(id) {
      this.formLoading = true;
      const {
        status,
        message,
        data,
      } = await detailContract(id);
      this.formLoading = false;
      if (status !== null) return this.$message.warning(message);
      this.detailData = data;
    },
  }
}
</script>


<style scoped lang="scss">

</style>
